// YouTubeEmbed: thumbnail-first, click-to-play YouTube embed.
//
// Powered by `react-lite-youtube-embed`. The iframe loads ONLY when the user
// clicks play — zero JS / cookies / iframe on initial page load.
//
// Renders the LiteYouTubeEmbed directly (no wrapper div) so the consumer's
// layout container (e.g. `.talkcard__thumb`) sizes it properly. Apply size by
// putting this in a container with width: 100% — the lite library handles the
// 16:9 aspect ratio internally via CSS.

import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export interface YouTubeEmbedProps {
  /** YouTube video ID (the v= param). */
  id: string;
  /** Accessible title — required for accessibility. */
  title: string;
  /**
   * Poster image resolution. YouTube returns a grey placeholder for
   * `maxresdefault` on videos lacking a high-res thumb; `hqdefault` always exists.
   */
  poster?: 'default' | 'mqdefault' | 'hqdefault' | 'sddefault' | 'maxresdefault';
  /** Extra className applied to the lite-youtube root. */
  wrapperClass?: string;
  /** Iframe URL params, e.g. "autoplay=1&start=42". */
  params?: string;
  /** Use youtube-nocookie.com (default: true). */
  noCookie?: boolean;
  /** Autoplay once the iframe loads. */
  autoplay?: boolean;
}

export function YouTubeEmbed({
  id,
  title,
  poster = 'hqdefault',
  wrapperClass,
  params,
  noCookie = true,
  autoplay,
}: YouTubeEmbedProps) {
  return (
    <LiteYouTubeEmbed
      id={id}
      title={title}
      poster={poster}
      noCookie={noCookie}
      {...(wrapperClass ? { wrapperClass: `yt-lite ${wrapperClass}` } : {})}
      {...(params ? { params } : {})}
      {...(autoplay !== undefined ? { activatedClass: 'lyt-activated' } : {})}
    />
  );
}
